import {css, StyleSheet} from 'aphrodite';
import * as React from 'react';
import {useState} from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import runModal from 'ui-library/runModal';
import CreateWorklistWithCollaboratorsModal from 'worklists/CreateWorklistWithCollaboratorsModal';
import {renderWorklistTypeOptions} from 'worklists/renderWorklistTypeOptions';
import {RefreshOptions} from 'worklists/WorklistActions';
import {WorklistType, worklistTypeDisplayName} from 'worklists/WorklistConstants';

export interface WorklistCreateButtonProps {
  buttonStyle: ButtonStyle;
  refreshOptions?: RefreshOptions;
}

export default function WorklistCreateButton(props: WorklistCreateButtonProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const openCreateWorklistModal = (selectedType: WorklistType) => {
    runModal(CreateWorklistWithCollaboratorsModal, {
      refreshOptions: props.refreshOptions,
      worklistType: selectedType,
    });
  };
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const getCreateWorklistOptionText = (worklistType: WorklistType) =>
    `Create ${worklistTypeDisplayName(worklistType)} worklist`;
  return (
    <Dropdown
      className={css(styles.dropdown)}
      isOpen={isOpen}
      onToggle={(newIsOpen) => {
        setIsOpen(newIsOpen);
      }}
      menu={
        <Menu
          height={Menu.HEIGHTS.MEDIUM}
          width={Menu.WIDTHS.LARGE}
          onMouseLeave={() => {
            setIsOpen(false);
          }}
          dropLeft={true}
        >
          {renderWorklistTypeOptions({
            onSelectWorklistType: openCreateWorklistModal,
            getOptionText: getCreateWorklistOptionText,
          })}
        </Menu>
      }
    >
      <Tooltip title="New worklist" placement={TooltipPlacement.BOTTOM} container="body" disabled={false}>
        <Button
          onClick={() => {
            setIsOpen(true);
          }}
          buttonStyle={props.buttonStyle}
          size={ButtonSize.SMALL}
          icon="compose"
          dataTestAttrs={{component: 'WorklistCreateButton', element: 'button'}}
        />
      </Tooltip>
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  dropdown: {
    marginTop: 1,
  },
});
